<template>
  <div class="btn-group">
    <button
      class="btn btn-secondary"
      @click.stop.prevent="routerPush('studio')">
      스튜디오
    </button>
    <button
      class="btn btn-secondary"
      @click.stop.prevent="routerPush('assistBoard')">
      진행자
    </button>
    <button
      class="btn btn-secondary"
      @click.stop.prevent="routerPush('watch')">
      시청자
    </button>
    <button
      class="btn btn-secondary"
      @click.stop.prevent="popup('chat')">
      채팅
    </button>
  </div>
</template>

<script>
export default {
  name: 'RoomItemButtons',

  props: {
    rid: String,
    mode: String
  },

  methods: {
    routerPush (name) {
      this.$router.push({ name, params: { rid: this.rid, mode: this.mode } })
    },
    popup (name) {
      window.open(this.$router.resolve({
        name, params: { rid: this.rid, mode: this.mode }
      }).href,
      '_blank',
      `directories=0,titlebar=0,toolbar=0,status=0,menubar=0,scrollbars=no,width=400,height=600`
      )
    }
  }
}
</script>

<style scoped>
</style>
